/**
 * Permission Management types
 * Requirements: 15.1-15.9 - Permission management
 */

export enum PermissionLevel {
  COMPANY_WIDE = 'COMPANY_WIDE',
  DEPARTMENT = 'DEPARTMENT',
  SELF_ONLY = 'SELF_ONLY',
}

export interface PermissionHistoryItem {
  id: string;
  oldValue: string | null;
  newValue: string;
  timestamp: string;
  changedBy: {
    id: string;
    name: string;
  } | null;
}

export interface SetPermissionDTO {
  permissionLevel: PermissionLevel;
}

export interface PermissionHistoryResponse {
  employeeId: string;
  history: PermissionHistoryItem[];
}

export interface EmployeesByPermissionResponse {
  permissionLevel: PermissionLevel;
  count: number;
  employees: Array<{
    id: string;
    email: string;
    name: string;
    jobTitle?: string;
    permissionLevel: PermissionLevel;
    companyId?: string;
    companyName?: string;
    departments: Array<{
      id: string;
      name: string;
      isPrimary: boolean;
    }>;
  }>;
}
